export default "__VITE_ASSET__1xVujQAnrZ6JFQDaGUnEXg__"